import React from "react";
import CustomCard from "../../components/cards/CustomCard";
import { Box, Divider, Flex } from "@chakra-ui/react";
import CustomText from "../../components/text/CustomText";
import GoldLine from "../../svgs/GoldLine";
import BgGradientLines from "../../assets/images/bg-lines.png";

function ExhibitorsAge() {
  return (
    <CustomCard maxW="288px">
      <Flex gap="16px" align="center">
        <CustomText
          text="Exhibitors Age"
          wrap="nowrap"
          color="yess.base_black"
        />
        <Divider bg="#F2F2F2" />
      </Flex>
      <Flex flexDir="column" gap="8px" mt="24px">
        {AGE_GROUPS.map((age, index) => (
          <Flex key={index} gap="12px" align="flex-start">
            <Box maxW="33px" w="100%">
              <CustomText
                text={age.title}
                color="yess.neutral700"
                size="10px"
                align="end"
                mt="3px"
              />
            </Box>
            <Flex
              w="100%"
              h="24px"
              borderRadius="4px"
              background={`url(${BgGradientLines}), rgba(242, 242, 242, 0.75)`}
              backgroundRepeat="no-repeat"
              backgroundSize="cover"
              //   backgroundPosition="right"
            >
              <Flex
                p="4px"
                bg="#e9e9e9"
                w={age.value}
                h="24px"
                borderRadius="4px"
                zIndex="10"
              >
                <Box bg="#2EC19E" borderRadius="4px" w="100%" />
              </Flex>
              <Box mt="5px" ml="-2px" zIndex="1">
                <GoldLine />
              </Box>
            </Flex>
            <Box maxW="22px" w="100%">
              <CustomText
                text={age.value}
                color="yess.neutral700"
                size="10px"
                mt="3px"
              />
            </Box>
          </Flex>
        ))}
      </Flex>
    </CustomCard>
  );
}

const AGE_GROUPS = [
  {
    title: "51 - 60",
    value: "54%",
  },
  {
    title: "41 - 50",
    value: "27%",
  },
  {
    title: "31 - 40",
    value: "54%",
  },
  {
    title: "21 - 30",
    value: "24%",
  },
  {
    title: "11 - 20",
    value: "54%",
  },
  {
    title: "1 - 10",
    value: "73%",
  },
];

export default ExhibitorsAge;
